import { createSlice } from "@reduxjs/toolkit";
import http from "../../common/cticApi";
import { setSucessTab } from "../orders/orderSlice";
import CryptoJS from "crypto-js";
import {
  GetEditOrderDetails,
  setEditOrderDetails,
} from "../ordersSummary/orderSummarySlice";
import { lawFirmSelector } from "../lawFirm/lawFirmSlice";
import { useSelector } from "react-redux";
import { parse } from "date-fns";
// initial state
export const initialState = {
  loading: false,
  error: null,
  success: false,
  lawyerInfo: null,
  assistantInfo: null,
  lawyerDefaults: null,
  locationInfo: null,
  postOrderDetailsInfo: null,
  fileDetailsInfo: null,
  programCodeDetails: null,
  staticQuestionDisableDetails: null,
  importedNPSFileDetails: null,
};
// our slice
const orderLawyerInfoSlice = createSlice({
  name: "orderLawyerInfo",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    setError: (state, { payload }) => {
      state.loading = false;
      state.error = payload;
      state.success = false;
    },
    setSuccess: (state) => {
      state.loading = false;
      state.error = false;
      state.success = true;
    },
    setLawyerInfo: (state, { payload }) => {
      state.lawyerInfo = payload;
    },
    setAssistantInfo: (state, { payload }) => {
      state.assistantInfo = payload;
    },
    setLawyerDefaults: (state, { payload }) => {
      state.loading = false;
      state.lawyerDefaults = payload;
    },
    setLocationInfo: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.locationInfo = payload;
    },
    setPostOrderDetailsInfo: (state, { payload }) => {
      state.postOrderDetailsInfo = payload;
      window.sessionStorage.setItem(
        "fileInfo",
        CryptoJS.AES.encrypt(
          JSON.stringify(payload),
          process.env.REACT_APP_CRYPTO_KEY
        ).toString()
      );
    },
    setFileDetailsInfo: (state, { payload }) => {
      state.fileDetailsInfo = payload;
      window.localStorage.setItem(
        "FileDetails",
        CryptoJS.AES.encrypt(
          JSON.stringify(payload),
          process.env.REACT_APP_CRYPTO_KEY
        ).toString()
      );
      // if (
      //   state.postOrderDetailsInfo === null ||
      //   state.postOrderDetailsInfo?.fileID === undefined ||
      //   state.postOrderDetailsInfo?.dealType === undefined
      // ) {
      if (payload !== null) {
        let request = {
          fileID: payload?.fileID,
          fileNumber: payload?.fileNumber,
          dealType: payload?.commercial === 0 ? "Residential" : "Commercial",
          fileStatus: payload?.status,
        };
        state.postOrderDetailsInfo = request;
      }
      //}
    },
    setProgramCodeDetails: (state, { payload }) => {
      window.localStorage.setItem(
        "ProgramCodeDetails",
        CryptoJS.AES.encrypt(
          JSON.stringify(payload),
          process.env.REACT_APP_CRYPTO_KEY
        ).toString()
      );
      state.programCodeDetails = payload;
    },
    setStaticQuestionDisableDetails: (state, { payload }) => {
      state.staticQuestionDisableDetails = payload;
    },
    setImportedNPSDetails: (state, { payload }) => {
      state.importedNPSFileDetails = payload;
    },
  },
});

// export the actions
export const {
  setLoading,
  setError,
  setSuccess,
  setLawyerInfo,
  setAssistantInfo,
  setLawyerDefaults,
  setLocationInfo,
  setPostOrderDetailsInfo,
  setFileDetailsInfo,
  setProgramCodeDetails,
  setStaticQuestionDisableDetails,
  setImportedNPSDetails,
} = orderLawyerInfoSlice.actions;

export const orderLawyerInfoSelector = (state) => state.orderLawyerInfo;

// export the default reducer
export default orderLawyerInfoSlice.reducer;


// get order lawyer info
export const GetOrderLawyerInformations =
  (userid, username, isLawyer, isInternalUser, firmid) => async (dispatch) => {
    try {
      dispatch(setLoading());

      let req = {
        Username: username,
        UserId: userid,
        IsLawyer: isLawyer,
        IsInternalUser: isInternalUser,
        FirmID: (firmid !== null && firmid !== undefined) ? parseInt(firmid) : 0
      };
      let { data: response } = await http.post(
        "/Lawfirm/GetOrderLawyerInformation",
        req
      );
      if (response.responseCode == 0) {
        dispatch(setLawyerInfo(response.responseObject.lawyerDetails));
        dispatch(setAssistantInfo(response.responseObject.assistantDetails));
        dispatch(setLawyerDefaults(response.responseObject.lawyerDefaults));
      } else {
        dispatch(setError(response.responseDescription));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.title
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const GetLocationsByLawyer = (lawyerid) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      lawyerId: lawyerid,
    };

    const results = await http
      .post("Lawfirm/GetLocationsByLawyer", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setLocationInfo(results.data.responseObject.locations));
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetAssistantByLawyer =
  (lawyerid, isLawyer, isInternalUser,firmID) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let req = {
        lawyerId: lawyerid,
        isLawyer: isLawyer,
        isInternalUser: isInternalUser,
        firmID: firmID,
      };

      const results = await http
        .post("Lawfirm/GetAssistantsByLawyer", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setSuccess());
        dispatch(setAssistantInfo(results.data.responseObject));
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const SubmitOrderLawyerInfo =
  (
    data,
    userName,
    promocode,
    postOrderDetailsInfo,
    userid,
    FirmID,
    { setTabValue, val }
  ) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let requestData = {
          LawyerID: parseInt(data.lawyerornotaryofrecord),
          OrderingLawyerID: data.orderinglawyerornotary ? parseInt(data.orderinglawyerornotary) : -1,
          LocationID: parseInt(data.officelocation),
          AssistantID: data.assistant !== "" ? parseInt(data.assistant) : -1,
          InternalReference: data.fileorreferencenumber,
          // recievedQuoteForOrder: data.recievedquotefororder,
          QuoteNumber:
            data.recievedquotefororder === "Yes"
              ? data.quotenumber != undefined
                ? data.quotenumber
                : null
              : "",
          //programOrLenderCodeUsed: data.programcodeusedfororder,
          ProgramCode:
            data.programcodeusedfororder === "Yes"
              ? data.programcode != undefined
                ? data.programcode
                : promocode
              : "",
          LenderCode: data.lendercode != undefined ? data.lendercode : null,
          FileLanguage: data.prefferredlanguageofpolicy,
          DealType: data.dealtype,
          FileID:
            postOrderDetailsInfo?.fileID === undefined
              ? 0
              : postOrderDetailsInfo.fileID,
          Username: userName,
          Status:
            postOrderDetailsInfo?.fileID === undefined
              ? ""
              : postOrderDetailsInfo.fileStatus,
          NPSFileNumber: data?.NPSFileNumber,
          FirmID: FirmID,
        };
        let { data: response } = await http.post(
          "/Order/SaveOrderLawyerInformation",
          requestData
        );
        if (response.responseCode == 0) {
          dispatch(setSuccess());
          setTabValue(typeof val === "number" ? val : 2, 2, true);
          dispatch(setSucessTab(2));
          dispatch(setPostOrderDetailsInfo(response.responseObject));
          if (data?.quotenumber || data?.programcode)
            dispatch(
              GetEditOrderDetails(response?.responseObject?.fileID, userid)
            );
        } else {
          dispatch(setError(response.responseDescription));
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.title
            : error.message;
        dispatch(setError(errorMessage));
      }
    };

export const GetFileDetails = (fileID) => async (dispatch) => {
  try {
    dispatch(setLoading());
    let req = {
      FileID: fileID,
    };

    const results = await http
      .post("Order/GetFileDetails", req)
      .then((result) => {
        return result;
      });

    if (results.data.responseCode == 0) {
      dispatch(setFileDetailsInfo(results.data.responseObject));
      dispatch(setSuccess());
    }
  } catch (error) {
    const errorMessage =
      error.response && error.response.data
        ? error.response.data.message
        : error.message;
    dispatch(setError(errorMessage));
  }
};

export const GetProgramCodeDefaultData =
  (programCode, userid, internalUser) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let requestObj = {
        ProgramCode: programCode,
      };

      let req = { UserID: userid, RequestObject: requestObj };

      const results = await http
        .post("Order/GetProgramCodeDefaultData", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setProgramCodeDetails(results.data.responseObject));
        dispatch(
          GetDisabledStaticQuestionsForProgramCode(
            programCode,
            userid,
            internalUser
          )
        );
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

const GetDisabledStaticQuestionsForProgramCode =
  (programCode, userid, isInternalUser) => async (dispatch) => {
    try {
      dispatch(setLoading());
      let requestObj = {
        ProgramCode: programCode,
        IsInternalUser: isInternalUser,
      };

      let req = { UserID: userid, RequestObject: requestObj };

      const results = await http
        .post("QuestionAdmin/GetDisabledStaticQuestionsForProgramCode", req)
        .then((result) => {
          return result;
        });

      if (results.data.responseCode == 0) {
        dispatch(setStaticQuestionDisableDetails(results.data.responseObject));
        dispatch(setSuccess());
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data
          ? error.response.data.message
          : error.message;
      dispatch(setError(errorMessage));
    }
  };

export const ImportNPSFileDetails =
  (NPSFileNumber, ProgramCode, firmID, { setIsNPSError }) =>
    async (dispatch) => {
      try {
        dispatch(setLoading());
        let req = {
          FileNumber: NPSFileNumber,
          ProgramCode: ProgramCode,
          FirmID: firmID,
        };

        const results = await http
          .post("Order/ImportNPSFileDetails", req)
          .then((result) => {
            return result;
          });

        if (results.data.responseCode == 0) {
          dispatch(setImportedNPSDetails(results.data.responseObject));
          dispatch(setEditOrderDetails(results.data.responseObject));
          dispatch(setSuccess());
        } else {
          setIsNPSError(true);
          dispatch(setError(results.data.responseDescription));
        }
      } catch (error) {
        const errorMessage =
          error.response && error.response.data
            ? error.response.data.message
            : error.message;
        dispatch(setError(errorMessage));
      }
    };
